'use client';

import cx from 'classix';
import {
  type ReactNode,
  useEffect,
  useRef,
} from 'react';
import { MdClose } from 'react-icons/md';
import {
  useIsMounted,
  useOnClickOutside,
} from 'usehooks-ts';

import styles from './modal-old.module.scss';

export interface ModalOldProps {
  isActive: boolean;
  onClose: () => void;
}

interface ModalWithChildrenProps extends ModalOldProps {
  children: ReactNode;
}

// TODO: replace place of usage with component Modal
export default function ModalOld(props: ModalWithChildrenProps) {
  const {
    children,
    isActive,
    onClose,
  } = props;

  const isMounted = useIsMounted();

  const modalContentRef = useRef(null);

  useOnClickOutside(modalContentRef, onClose);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMounted]);

  return (
    <div className={cx(styles.modalOld, isActive && styles.modalOld__isActive)}>
      <div ref={modalContentRef} className={styles.modalOld_content}>
        <div className={styles.modalOld_close}>
          <MdClose onClick={onClose} />
        </div>
        {children}
      </div>
    </div>
  );
}
